// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { PERMISSION_LIST } from '../../config/API_Collection';
import { FETCH_USER_PERMISSIONS_FAILURE, FETCH_USER_PERMISSIONS_REQUEST, FETCH_USER_PERMISSIONS_SUCCESS } from '../Actions/Actions';
import { getErrorMessage } from '../../config/Error_Codes';




function* fetchProjectsSaga() {
  try {
    const response = yield call(Axios.get,PERMISSION_LIST);
    console.warn(response);
    
    const projects = response.data.data || [];
    yield put({type:FETCH_USER_PERMISSIONS_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:FETCH_USER_PERMISSIONS_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* userPermissionListSaga() {
  yield takeLatest(FETCH_USER_PERMISSIONS_REQUEST, fetchProjectsSaga);
}
